import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      params: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                _this.params = [];

                for (k in data) {
                  _this.params.push({
                    label: k,
                    value: data[k]
                  });
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};